
import { mapGetters } from 'vuex';
import Banner from '@components/Banner.vue';
import DirectoryBanners from '@components/DirectoryBanners.vue';
import Gallery from '@components/Gallery.vue';
import Showcase from '@components/Showcase.vue';
import VideoEmbed from '@components/Video.vue';
import Settings from '@components/Settings.vue';

export default {
  watch: {
    $route(to) {
      const rx = /\/index\.html/i;

      if (rx.test(to.path)) {
        this.$router.replace({ path: to.path.replace(rx, '') });
      }
    },
  },

  computed: {
    ...mapGetters(['currentResource']),

    what() {
      if (this.currentResource.isBanner()) {
        return this.currentResource.showcase() ? 'showcase' : 'banner';
      }

      if (this.currentResource.isDirectory()) {
        if (this.currentResource.gallery()) {
          return 'gallery';
        }

        if (this.currentResource.children().some(c => c.isBanner())) {
          return 'directory-banners';
        }
      }

      const type = this.currentResource.type();

      // additional whitelist of supported asset types vs. components
      if (type === 'video') {
        return 'video-embed';
      }

      return null;
    },
  },

  components: {
    Banner,
    DirectoryBanners,
    Gallery,
    Settings,
    Showcase,
    VideoEmbed,
  },
};
